import type { ReactNode } from 'react';
import clsx from 'clsx';

type Tone = 'brand' | 'success' | 'warn' | 'danger' | 'neutral' | 'info';

const toneClass: Record<Tone, string> = {
  brand:   'bg-etsy-50 text-etsy-700 border-etsy-200',
  success: 'bg-sage/10 text-sage border-sage/30',
  warn:    'bg-amber/10 text-amber border-amber/30',
  danger:  'bg-rose/10 text-rose border-rose/30',
  neutral: 'bg-cream-200 text-ink-600 border-cream-300',
  info:    'bg-sky/10 text-sky border-sky/30',
};

export function Badge({ tone = 'neutral', children, className }: { tone?: Tone; children: ReactNode; className?: string }) {
  return <span className={clsx('badge border', toneClass[tone], className)}>{children}</span>;
}

export function Dot({ tone = 'brand' }: { tone?: Tone }) {
  const color = {
    brand:   'bg-etsy',
    success: 'bg-sage',
    warn:    'bg-amber',
    danger:  'bg-rose',
    neutral: 'bg-ink-300',
    info:    'bg-sky',
  }[tone];
  return <span className={clsx('h-1.5 w-1.5 rounded-full', color, 'shadow-[0_0_8px_currentColor]')} />;
}
